import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { ApiGenericResponse } from "../../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../../Command";

const ENDPOINT = "/dashboard/widget";

export class UpdateDashboardWidgetCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "put";
    widget: DashboardWidget;

    constructor(widget: DashboardWidget, breakpoint: string) {
        super();
        this.widget = widget.clone();
        if (breakpoint) {
            // console.log("breakpoint: ", breakpoint);
            if (this.widget.positionAndSizeList.filter((p) => p.breakpoint == breakpoint).length != 1) {
                var obj = { breakpoint: breakpoint, x: 0, y: 0, width: 2, height: 2 };
                this.widget.positionAndSizeList.push(obj);
            }

            this.widget.positionAndSizeList.filter((p) => p.breakpoint == breakpoint)[0].x = widget.x;
            this.widget.positionAndSizeList.filter((p) => p.breakpoint == breakpoint)[0].y = widget.y;
            this.widget.positionAndSizeList.filter((p) => p.breakpoint == breakpoint)[0].width = widget.width;
            this.widget.positionAndSizeList.filter((p) => p.breakpoint == breakpoint)[0].height = widget.height;
        }
        this.widget.positionAndSizeList = this.widget.positionAndSizeList.filter((p) => p.breakpoint != null);
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.widget);
        return new ApiGenericResponse(res);
    }
}
